import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=c5c0ea1a"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5c0ea1a')) {
      api.createRecord('c5c0ea1a', component.options)
    } else {
      api.reload('c5c0ea1a', component.options)
    }
    module.hot.accept("./DeviceManagement.vue?vue&type=template&id=c5c0ea1a", function () {
      api.rerender('c5c0ea1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceManagement.vue"
export default component.exports